"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="221491" id="mondaymorningmuster" className="relative w-full min-h-[90vh] flex flex-col lg:flex-row bg-background overflow-hidden dark">
      {}
      <div ref={contentRef} className="flex-1 flex flex-col justify-center px-6 py-20 lg:px-16 xl:px-24 z-10">
        <div className="max-w-2xl">
          {}
          <div className={`overflow-hidden transition-all duration-700 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h1 className="font-default text-foreground uppercase leading-[0.85] tracking-tighter mb-8 !text-8xl">MONDAY MORNING MUSTER</h1>
          </div>

          {}
          <div className={`transition-all duration-700 delay-200 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <p className="text-lg md:text-xl text-foreground/80 mb-10 max-w-md font-sans">Weekly reminders to check in, stay connected, and never fight alone.</p>
          </div>

          {}
          <div className={`flex flex-wrap gap-4 transition-all duration-700 delay-400 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Link to="https://paniolotrails.com/support-resources/">
              <Button size="lg" className="rounded-none bg-primary text-primary-foreground hover:bg-primary/90 h-14 px-8 text-lg font-default tracking-wider uppercase shadow-none">
                Need help now? View Resources
                <ArrowRight className="ml-2 size-5" />
              </Button>
            </Link>
            <Link to="https://www.facebook.com/profile.php?id=61578128985257">
              <Button variant="outline" size="lg" className="rounded-none border-2 border-foreground text-foreground hover:bg-foreground hover:text-background transition-all duration-300 h-14 px-8 text-lg font-default tracking-wider uppercase shadow-none">
                Follow the Weekly Muster
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="flex-1 relative min-h-[50vh] lg:min-h-full overflow-hidden bg-muted">
        {}
        <div className="absolute inset-0 bg-primary/10 z-10 mix-blend-multiply pointer-events-none"></div>
        <img src="https://paniolotrails.com/wp-content/uploads/2026/04/MMM3_smaller-for-web.png" alt="Cinematic mountain trail at sunrise representing the Paniolo Trails mission" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[2000ms] ease-out hover:scale-105 grayscale hover:grayscale-0" />
      </div>
    </section>;
}